import { useMemo } from "react";
import SelectBoxSingle from "../selectbox-single";
import { IKetQuaLienHeItem } from "./useKetQuaLienHe";

interface ISelectBoxKetQuaLienHeProps {
    ketQuaLienHes: IKetQuaLienHeItem[];
    value?: number | null;
    onValueChanged: (id?: number) => void;
    placeholder?: string;
    disabled?: boolean;
    width?: string | number;
}

const SelectBoxKetQuaLienHe = (props: ISelectBoxKetQuaLienHeProps) => {
    const items = useMemo(
        () => props.ketQuaLienHes.map(x => ({ id: x.id, text: x.ten_ket_qua })),
        [props.ketQuaLienHes]
    );

    return (
        <SelectBoxSingle
            items={items}
            value={props.value || undefined}
            onValueChanged={(v) => props.onValueChanged(v === undefined ? undefined : Number(v))}
            placeholder={props.placeholder ?? "Chọn kết quả"}
            disabled={props.disabled}
            width={props.width}
        />
    );
};

export default SelectBoxKetQuaLienHe;
